"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressType = exports.Salutation = void 0;
var Salutation;
(function (Salutation) {
    Salutation["None"] = "0";
    Salutation["Mr"] = "1";
    Salutation["Mrs"] = "2";
})(Salutation || (exports.Salutation = Salutation = {}));
var AddressType;
(function (AddressType) {
    AddressType[AddressType["None"] = 0] = "None";
    AddressType["Domicil"] = "domicilAddress";
    AddressType["Delivery"] = "deliveryAddress";
    AddressType["Temporary"] = "temporaryAddress";
    AddressType["Billing"] = "billingAddress";
})(AddressType || (exports.AddressType = AddressType = {}));
//# sourceMappingURL=addresses.js.map